import { useEffect } from "react";
import useFetch from "../hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

import 'react-datepicker/dist/react-datepicker.css';
import MusicTable from "../components/Music/MusicTable";
import CSVMusicUpload from "../components/Music/CsvMusicUpload";
import DownloadAllMusicCsv from "../components/Music/DownloadAllMusicCsv";
import ToggleLockSongs from "../components/Music/ToggeLockSongs";

const EventMusic = () => {
  const navigate = useNavigate();
  
  const { event_id } = useParams<{ event_id: string }>();
  const {
    data: data,
    setData,
    errorContent,
    isLoading,
    fetchData,
    hasFetched,
  } = useFetch({
    url: `${import.meta.env.VITE_API_URL}/events/${event_id}/music`,
    method: "GET",
  });

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (errorContent) return errorContent;
  if (!hasFetched) return null;
  if (isLoading) return <p>Loading music...</p>;

  const handleUploadSuccess = (newSongs: any[]) => {
    if (setData) {
      setData((prevData: any) => {
        const updatedData = {
          ...prevData,
          songs: newSongs,
        };
        return updatedData;
      });
    }
  };

    const handleSongUpdate = (updatedSong: any) => {
      if (setData) {
        if (updatedSong._deleted) {
          fetchData();
        } else {
        setData((prevData: any) => ({
          ...prevData,
          songs: prevData.songs.map((s: any) => 
            s.id === updatedSong.id ? { ...s, ...updatedSong } : s
          ),
        }));
      }
      }
    };

  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;
  const isAdmin = Number(currentRole) === 1;
  const canSeeCSVFileUpload = isAdmin;

  const canAddMusicRecord = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "eventsongs")?.ModulesPermissions?.add;
  const canViewMusic = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "music")?.ModulesPermissions?.view;

  
  return (
    <>
      {(canAddMusicRecord) ? 
          (<CSVMusicUpload
            competitionId={data?.competition?.id}
            event={data?.event}
            onUploadSuccess={handleUploadSuccess}
            canSeeCSVFileUpload={canSeeCSVFileUpload}
            onUploadComplete={fetchData}
          />) : null}
            

      <section className="headersection2">
        <div className="w-layout-blockcontainer container-main-content w-container">
          <div className="div-header-title-section" style={{display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap'}}>
            <div
              className="link-block w-inline-block cursor-pointer"
              onClick={() => navigate(`/events/${data?.competition?.id}`)}
            >
              <img src="/images/back-icon.png" loading="lazy" alt="" className="image-2"/>
              <h1 className="back-text-link">{data?.competition?.title}</h1>
            </div>
            
            <h1 className="judgingapp-heading2">{data?.event?.location}</h1>
            <p className="paragraph-2">
               {data?.event?.start_date}
            </p>
          </div>
        </div>
      </section>
      {canViewMusic ? (
      <section style={{backgroundColor: 'white', padding: '20px 0'}}>
        <div className="w-layout-blockcontainer container-main-content w-container">
          <div className="download-music-csv-wrapper">
            {isAdmin && (
              <ToggleLockSongs
                event={data?.event}
                onToggle={(locked) => {
                  setData((prev: any) => ({...prev, event: { ...prev.event, lock_songs: locked ? 1 : 0 },}));
                }}
            /> )}
            {(canAddMusicRecord) ? (
            <DownloadAllMusicCsv event={data?.event} />
            ) : null}
          </div>
          <MusicTable key={data?.songs?.length || 0} data={data?.songs || []} event={data?.event || null} onSongUpdate={handleSongUpdate} />
        </div>
      </section>
      ) : null}

    </>
  );
};

export default EventMusic;